(ns common.schema.entities.value-creation.core
  "Common entity-type definition of the value creation. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the value creation documents with the calculated fields."
  (:require
   [common.schema.entities.value-creation.schema :as value-creation]
   [common.schema.entities.value-creation.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/value-creation
   :schema                       value-creation/new-value-creation
   :name                         {:en "Value creation"}
   :plural                       {:en "Value creation"}
   :icon                         :fa-edit
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
